export default __webpack_public_path__ + "static/coins-88d68a94d424caa5db458b4ad416c797.png";